let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dPMOS")).then(() => parcelRequire('9zsf7'));